import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { FormProvider, useForm, useWatch } from 'react-hook-form';
import RMSCheckbox from 'features/shared/components/form-controls/RMSCheckbox';
import PersonHistorySnapshotsGrid from './PersonHistorySnapshotsGrid';
import PersonHistoryChangesGrid from './PersonHistoryChangesGrid';

const PersonHistoryTab = ({ personId }) => {
  const methods = useForm({ defaultValues: { showAllSnapshots: false } });
  const showAllSnapshots = useWatch({ control: methods.control, name: 'showAllSnapshots' });

  return (
    <Box className="person-history-tab">
      <Box className="person-history-tab__toolbar">
        <Typography variant="subtitle1">Change History</Typography>
        <FormProvider {...methods}>
          <RMSCheckbox name="showAllSnapshots" label="Show all snapshots" />
        </FormProvider>
      </Box>
      {showAllSnapshots ? (
        <PersonHistorySnapshotsGrid personId={personId} />
      ) : (
        <PersonHistoryChangesGrid personId={personId} />
      )}
    </Box>
  );
};

export default PersonHistoryTab;
